// removed by extract-text-webpack-plugin
module.exports = {"button":"_1pg0","s2":"oW6K","position":"_1zCL","active":"_23aw","blue":"_23pZ","green":"RBZg","red":"_3kg_","s0":"p4fG","s1":"_2TvZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/keyboard/button/index.less
// module id = 264
// module chunks = 0